import { render } from "./JobProfileCard.vue?vue&type=template&id=941cf9ee"
import script from "./JobProfileCard.vue?vue&type=script&lang=js"
export * from "./JobProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__